import { ApolloClient } from 'apollo-client';
import { WebSocketLink } from 'apollo-link-ws';
import { HttpLink } from 'apollo-link-http';
import { split, concat, ApolloLink } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache } from 'apollo-cache-inmemory';
import store from '@/store';

const httpurl = process.env.VUE_APP_GRAPHQL_HTTP || 'https://carelaql.devtunnel.org/v1/graphql';
const wsurl = process.env.VUE_APP_GRAPHQL_WSS || 'wss://carelaql.devtunnel.org/v1/graphql';

class GraphClient {
  constructor(getBearer) {
    const wsLink = new WebSocketLink({
      uri: wsurl,
      options: {
        reconnect: true,
        connectionParams: {
          headers: {
            Authorization: `Bearer ${getBearer()}`,
          },
        },
      },
    });
    const httpLink = new HttpLink({
      uri: httpurl,
    });

    const link = split(
      // split based on operation type
      ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return kind === 'OperationDefinition' && operation === 'subscription';
      },
      wsLink,
      httpLink,
    );

    const authMiddleware = new ApolloLink((operation, forward) => {
      operation.setContext({
        headers: {
          Authorization: `Bearer ${getBearer()}`,
          'x-hasura-user-id': store.state.auth.user.keycloak.idTokenParsed['hasura-auth']['x-hasura-user-id'],
        },
      });
      return forward(operation);
    });

    this.client = new ApolloClient({
      link: concat(authMiddleware, link),
      cache: new InMemoryCache(),
    });
  }
}

export default GraphClient;
